module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/instagram-white-ff8cd5039fd46f04b9a0ea00bdce5e1f.svg";